import { createAxios } from "./axiosHttpMarconi";

export const aduanaService = {
  getIncoterms,
  postIncoterm,
  sendToUps,
  deleteUps,
  sendToFedex,
};

function getIncoterms(idEnvio) {
  const axios = createAxios();
  const user = JSON.parse(localStorage.getItem("user"));
  let urlPath = `/franquicia/${user.extraData.franquiciaId}/envio/${idEnvio}/incoterms`;
  return axios.get(urlPath);
}

function postIncoterm(req) {
  const axios = createAxios();
  const user = JSON.parse(localStorage.getItem("user"));
  let urlPath = `/franquicia/${user.extraData.franquiciaId}/aduana`;
  return axios.post(urlPath, req);
}

function sendToUps(req) {
  const axios = createAxios();
  const user = JSON.parse(localStorage.getItem("user"));
  let urlPath = `/franquicia/${user.extraData.franquiciaId}/aduana/ups`;
  return axios.post(urlPath, req);
}

function sendToFedex(req) {
  const axios = createAxios();
  const user = JSON.parse(localStorage.getItem("user"));
  let urlPath = `/franquicia/${user.extraData.franquiciaId}/aduana/fedex`;
  return axios.post(urlPath, req);
}

function deleteUps(idFile) {
  const axios = createAxios();
  const user = JSON.parse(localStorage.getItem("user"));
  let urlPath = `/franquicia/${user.extraData.franquiciaId}/aduana/ups/${idFile}`;
  return axios.delete(urlPath);
}
